import { useEffect, useState } from 'react';
import { useForceUpdate } from '../utils/useForceUpdate';

export function useMatchMedia(query: string) {
  const [mediaQueryList] = useState(() => matchMedia(query));
  const forceUpdate = useForceUpdate();

  useEffect(() => {
    mediaQueryList.addEventListener('change', forceUpdate);

    return () => {
      mediaQueryList.removeEventListener('change', forceUpdate);
    };
  }, [mediaQueryList]);

  return mediaQueryList.matches;
}
